/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InlineObject17
 */
export interface InlineObject17 {
    /**
     * 
     * @type {number}
     * @memberof InlineObject17
     */
    aktid: number;
    /**
     * 
     * @type {boolean}
     * @memberof InlineObject17
     */
    sendreply?: boolean;
}

export function InlineObject17FromJSON(json: any): InlineObject17 {
    return InlineObject17FromJSONTyped(json, false);
}

export function InlineObject17FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineObject17 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'aktid': json['aktid'],
        'sendreply': !exists(json, 'sendreply') ? undefined : json['sendreply'],
    };
}

export function InlineObject17ToJSON(value?: InlineObject17 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'aktid': value.aktid,
        'sendreply': value.sendreply,
    };
}


